import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function ChangePassword() {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }

    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    if (currentPassword === newPassword) {
      setError('New password must be different from current password');
      return;
    }

    setLoading(true);

    try {
      const { updatePassword } = await import('aws-amplify/auth');
      await updatePassword({
        oldPassword: currentPassword,
        newPassword: newPassword
      });

      setSuccess('Password changed successfully!');
      setTimeout(() => {
        navigate('/dashboard');
      }, 2000);
    } catch (err) {
      console.error('Change password error:', err);
      if (err.name === 'NotAuthorizedException') {
        setError('Current password is incorrect');
      } else {
        setError(err.message || 'Failed to change password. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '600px', margin: '60px auto', padding: '20px' }}>
      <div className="card" style={{ padding: '40px' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{ fontSize: '64px', marginBottom: '15px' }}>🔒</div>
          <h1 style={{ fontSize: '32px', marginBottom: '10px', color: '#4f46e5' }}>
            Change Password
          </h1>
          <p style={{ color: '#666', fontSize: '16px' }}>
            Update your account password
          </p>
        </div>

        {error && (
          <div style={{ 
            padding: '15px', 
            background: '#fee2e2', 
            border: '1px solid #ef4444',
            borderRadius: '8px',
            marginBottom: '20px',
            color: '#dc2626'
          }}>
            {error}
          </div>
        )}

        {success && (
          <div style={{ 
            padding: '15px', 
            background: '#d1fae5', 
            border: '1px solid #10b981',
            borderRadius: '8px',
            marginBottom: '20px',
            color: '#065f46'
          }}>
            {success}
          </div>
        )}

        <form onSubmit={handleChangePassword}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#333' }}>
              Current Password
            </label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              placeholder="Enter current password"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '16px'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#333' }}>
              New Password
            </label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              placeholder="At least 8 characters"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '16px'
              }}
            />
            <p style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
              Must be at least 8 characters with uppercase, lowercase, and numbers
            </p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#333' }}>
              Confirm New Password
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="Re-enter new password"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '16px'
              }}
            />
          </div>

          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary"
              style={{ flex: 1, padding: '14px', fontSize: '16px' }}
            >
              {loading ? 'Changing...' : 'Change Password'}
            </button>
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              className="btn-secondary"
              style={{ flex: 1, padding: '14px', fontSize: '16px' }}
            >
              Cancel
            </button>
          </div>
        </form>

        <div style={{ 
          marginTop: '30px', 
          padding: '20px', 
          background: '#f0f9ff', 
          borderRadius: '8px',
          border: '1px solid #bfdbfe'
        }}>
          <h3 style={{ fontSize: '16px', marginBottom: '10px', color: '#1e40af' }}>
            💡 Password Tips:
          </h3>
          <ul style={{ fontSize: '14px', color: '#1e3a8a', lineHeight: '1.8', marginLeft: '20px' }}>
            <li>Use at least 8 characters</li>
            <li>Include uppercase and lowercase letters</li>
            <li>Add numbers and special characters</li>
            <li>Don't reuse passwords from other sites</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
